import { DownOutlined } from '@ant-design/icons'
import { Button, Dropdown } from 'antd'

export const ActionMenu = ({ items = [], children }) => (
  <Dropdown menu={{ items }}>
    {children ? (
      children
    ) : (
      <Button>
        Actions <DownOutlined />
      </Button>
    )}
  </Dropdown>
)
